import { AuditSchedule, DateStr, toDateRange, today } from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListingView } from '../../../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../../../core/reports/types';
import { SchedulesListSpotForm } from './form';
import { SchedulesListSpotResult } from './result';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
}

export type SchedulesSpotListing = ListingType<
  { from: string; to: string; customId: string },
  AuditSchedule
>;

export function SchedulesSpotListView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<SchedulesSpotListing>
      defaultValues={{
        ...toDateRange(today() as DateStr, tz),
        customId: '',
        sort: 'datetime desc',
      }}
      queryParamsTransform={{
        customId: {
          serialize: (input: string) => {
            return input.replace(/\s/g, '');
          },
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchSchedules(p.station.slug, {
          page: values.pageIndex,
          filter: {
            type: 'SPOT',
            'datetime.gte': values.from,
            'datetime.lte': values.to,
            customId: values.customId
              ?.split(',')
              .filter((v) => !!v)
              .map((v) => v.trim()),
          },
          contain: 'audio,matches',
        });
      }}
      Form={SchedulesListSpotForm}
      Result={SchedulesListSpotResult}
    />
  );
}
